'use client';
import React, { useEffect, useState } from 'react';

interface TypingProps {
	text: string;
	className?: string;
	typingSpeed?: number; // Speed of typing in milliseconds
	pauseDuration?: number; // Duration of pause in milliseconds
}

const Typing: React.FC<TypingProps> = ({
	text,
	className,
	typingSpeed = 100, // Default typing speed
	pauseDuration = 2000 // Default pause duration
}) => {
	const [content, setContent] = useState('');
	const [isTyping, setIsTyping] = useState(true);
	const [index, setIndex] = useState(0);

	useEffect(() => {
		let timeoutId: NodeJS.Timeout;

		if (isTyping) {
			if (index < text.length) {
				timeoutId = setTimeout(() => {
					setContent(text.substring(0, index + 1));
					setIndex(index + 1);
				}, typingSpeed);
			} else {
				// After typing is done, wait for the pause duration
				timeoutId = setTimeout(() => {
					setIsTyping(false); // Start erasing
				}, pauseDuration);
			}
		} else {
			if (index > 0) {
				timeoutId = setTimeout(() => {
					setContent(text.substring(0, index - 1));
					setIndex(index - 1);
				}, typingSpeed);
			} else {
				setIsTyping(true); // Once erasing is done, start typing again
			}
		}

		return () => {
			clearTimeout(timeoutId); // Clear timeout if the component is unmounted
		};
	}, [index, text, isTyping, typingSpeed, pauseDuration]);

	return <div className={className}>{content}</div>;
};

export default Typing;
